import { useContext } from 'react';
import styles from '../style/projects.module.css';
import projectCopy from '../translations/projects';
import LanguageContext from '../context/language.context';
import ProjectShowcase from './ProjectShowcase';
import ProjectCard from './ProjectCard';

export default function Projects() {
  const { language } = useContext(LanguageContext);

  const ui = projectCopy[language];
  const list = projectCopy.projects;
  const featured = list.filter((p) => p.layout === 'showcase');
  const study = list.filter((p) => p.layout === 'card');

  return (
    <section
      id="projects"
      className={ styles.container }
      aria-labelledby="projects-heading"
    >
      <div className={ styles.containerTitle }>
        <h1 id="projects-heading" className={ styles.title }>{ui.title}</h1>
        <p className={ styles.subtitle }>{ui.subTitle}</p>
      </div>

      <div className={ styles.section }>
        <h2 className={ styles.sectionLabel }>{ui.featuredLabel}</h2>
        <div className={ styles.showcaseStack }>
          {featured.map((project) => (
            <ProjectShowcase
              key={ project.title }
              project={ project }
              language={ language }
              ui={ ui }
            />
          ))}
        </div>
      </div>

      <div className={ `${styles.section} ${styles.sectionStudy}` }>
        <h2 className={ styles.sectionLabel }>{ui.studyLabel}</h2>
        <div className={ styles.gridStudy }>
          {study.map((project) => (
            <ProjectCard
              key={ project.title }
              project={ project }
              language={ language }
              ui={ ui }
            />
          ))}
        </div>
      </div>
    </section>
  );
}
